import React from 'react';

// import { ReactComponent as Logo } from '../../assets/img/logo-footer.svg';
import newLogo from '../../assets/img/TotalEnergies_Logo_RGB.png';

import './Footer.scss';

export default function Footer(): JSX.Element {
  return (
    <div className="Footer">
      <div className="total-container">
        <div className="Footer__content">
          <div className="Footer__logo fcc">
            {/* <Logo /> */}
            <img src={newLogo} alt="logo" />
          </div>
          <div className="Footer__text">
            <p>
              The above information is supplied without any assumption of liability and you accept,
              by accepting the information, that we are not liable to you for your use of the
              information. While reasonable endeavours are taken to ensure that the information in
              this report is obtained from reliable sources, it is not guaranteed for accuracy. The
              views set forth are solely of those of the authors and not intended to provide advice
              or recommendations as the customer is solely responsible for its market decisions.
              Views expressed are subject to change without notice. Be aware that views stated are
              incidental to the business of TotalEnergies Gas and Power Limited. and its affiliates
              which are engaged in swaps, forwards, options and cash transactions for their own
              accounts. The information must not be copied, distributed or published without our
              express permission.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
